import { render, staticRenderFns } from "./ColoredSquare.vue?vue&type=template&id=10a938c3&scoped=true&"
import script from "./ColoredSquare.vue?vue&type=script&lang=js&"
export * from "./ColoredSquare.vue?vue&type=script&lang=js&"
import style0 from "./ColoredSquare.vue?vue&type=style&index=0&id=10a938c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a938c3",
  null
  
)

export default component.exports